import * as routes from '../utils/constants/routes';
import SubscribedUsers from './users/SubscribedUsers';
import Organizations from './organizations/Organizations';
import React from 'react';
import { Route } from 'react-router';
import TopBar from './common/TopBar';
import styled from 'styled-components';
import colors from '../utils/colors';
import { Link } from 'react-router-dom';
import {
  AI_USAGE,
  ANALYTICS,
  AUTO_PLAN_FEEDBACK,
  CANCELLATIONS,
  COACHES,
  FIRST_WEEK,
  USAGE,
  INVITED_AND_OLD_USERS,
  ORGANIZATIONS,
  RESET_TRIALS,
  SCHEDULED_EMAILS,
  SYLLABUS_IMPORTS,
  SUBSCRIBED_USERS,
  UNREDEEMED_USERS
} from '../utils/constants/labels';
import { Layout, Menu } from 'antd';
import Organization from './organizations/Organization';
import Cancellations from './users/Cancellations';
import InvitedUsers from './users/InvitedUsers';
import Analytics from './analytics/Analytics';
import ResetTrials from './analytics/ResetTrials';
import FirstWeek from './analytics/FirstWeek';
import Usage from './analytics/Usage';
import UnredeemedUsers from './users/UnredeemedUsers';
import ScheduledEmails from './users/ScheduledEmails';
import Coaches from './users/Coaches';
import SyllabusImports from './ai/SyllabusImports';
import AiUsage from './ai/AiUsage';
import AutoPlanFeedbackPage from './users/AutoPlanFeedback';

const { Sider: AntSider, Content: AntContent } = Layout;
const { Item: AntMenuItem } = Menu;

enum DashboardItem {
  SUBSCRIBED_USERS = '1',
  INVITED_USERS = '2',
  ORGANIZATIONS = '3',
  CANCELLATIONS = '4',
  ANALYTICS = '5',
  RESET_TRIALS = '6',
  UNREDEEMED_USERS = '7',
  SCHEDULED_EMAILS = '8',
  COACHES = '9',
  SYLLABUS_IMPORTS = '10',
  AI_USAGE = '11',
  AUTO_PLAN_FEEDBACK = '12',
  FIRST_WEEK = '13',
  USAGE = '14'
}

const items = {
  [DashboardItem.SUBSCRIBED_USERS]: `${routes.DASHBOARD}${routes.SUBSCRIBED_USERS}`,
  [DashboardItem.INVITED_USERS]: `${routes.DASHBOARD}${routes.INVITED_USERS}`,
  [DashboardItem.ORGANIZATIONS]: `${routes.DASHBOARD}${routes.ORGANIZATIONS}`,
  [DashboardItem.COACHES]: `${routes.DASHBOARD}${routes.COACHES}`,
  [DashboardItem.CANCELLATIONS]: `${routes.DASHBOARD}${routes.CANCELLATIONS}`,
  [DashboardItem.ANALYTICS]: `${routes.DASHBOARD}${routes.ANALYTICS}`,
  [DashboardItem.RESET_TRIALS]: `${routes.DASHBOARD}${routes.RESET_TRIALS}`,
  [DashboardItem.UNREDEEMED_USERS]: `${routes.DASHBOARD}${routes.UNREDEEMED_USERS}`,
  [DashboardItem.SCHEDULED_EMAILS]: `${routes.DASHBOARD}${routes.SCHEDULED_EMAILS}`,
  [DashboardItem.SYLLABUS_IMPORTS]: `${routes.DASHBOARD}${routes.SYLLABUS_IMPORTS}`,
  [DashboardItem.AI_USAGE]: `${routes.DASHBOARD}${routes.AI_USAGE}`,
  [DashboardItem.AUTO_PLAN_FEEDBACK]: `${routes.DASHBOARD}${routes.AUTO_PLAN_FEEDBACK}`,
  [DashboardItem.FIRST_WEEK]: `${routes.DASHBOARD}${routes.FIRST_WEEK}`,
  [DashboardItem.USAGE]: `${routes.DASHBOARD}${routes.USAGE}`
};

const Dashboard = ({ match, location }) => {
  const { pathname } = location;
  return (
    <Container>
      <TopBar />
      <Wrapper>
        <Sider>
          <Menu defaultSelectedKeys={[getSelectedKey(pathname)]} mode="inline">
            <SiderItem key={DashboardItem.SUBSCRIBED_USERS}>
              <Link to={items[DashboardItem.SUBSCRIBED_USERS]}>{SUBSCRIBED_USERS}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.INVITED_USERS}>
              <Link to={items[DashboardItem.INVITED_USERS]}>{INVITED_AND_OLD_USERS}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.ORGANIZATIONS}>
              <Link to={items[DashboardItem.ORGANIZATIONS]}>{ORGANIZATIONS}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.COACHES}>
              <Link to={items[DashboardItem.COACHES]}>{COACHES}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.CANCELLATIONS}>
              <Link to={items[DashboardItem.CANCELLATIONS]}>{CANCELLATIONS}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.AUTO_PLAN_FEEDBACK}>
              <Link to={items[DashboardItem.AUTO_PLAN_FEEDBACK]}>{AUTO_PLAN_FEEDBACK}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.ANALYTICS}>
              <Link to={items[DashboardItem.ANALYTICS]}>{ANALYTICS}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.FIRST_WEEK}>
              <Link to={items[DashboardItem.FIRST_WEEK]}>{FIRST_WEEK}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.USAGE}>
              <Link to={items[DashboardItem.USAGE]}>{USAGE}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.RESET_TRIALS}>
              <Link to={items[DashboardItem.RESET_TRIALS]}>{RESET_TRIALS}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.UNREDEEMED_USERS}>
              <Link to={items[DashboardItem.UNREDEEMED_USERS]}>{UNREDEEMED_USERS}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.SCHEDULED_EMAILS}>
              <Link to={items[DashboardItem.SCHEDULED_EMAILS]}>{SCHEDULED_EMAILS}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.SYLLABUS_IMPORTS}>
              <Link to={items[DashboardItem.SYLLABUS_IMPORTS]}>{SYLLABUS_IMPORTS}</Link>
            </SiderItem>
            <SiderItem key={DashboardItem.AI_USAGE}>
              <Link to={items[DashboardItem.AI_USAGE]}>{AI_USAGE}</Link>
            </SiderItem>
          </Menu>
        </Sider>
        <Content>
          <Route path={items[DashboardItem.SUBSCRIBED_USERS]} component={SubscribedUsers} />
          <Route path={items[DashboardItem.INVITED_USERS]} component={InvitedUsers} />
          <Route exact path={items[DashboardItem.ORGANIZATIONS]} component={Organizations} />
          <Route exact path={items[DashboardItem.COACHES]} component={Coaches} />
          <Route path={`${routes.DASHBOARD}${routes.ORGANIZATIONS}/:id`} component={Organization} />
          <Route exact path={items[DashboardItem.CANCELLATIONS]} component={Cancellations} />
          <Route exact path={items[DashboardItem.AUTO_PLAN_FEEDBACK]} component={AutoPlanFeedbackPage} />
          <Route exact path={items[DashboardItem.ANALYTICS]} component={Analytics} />
          <Route exact path={items[DashboardItem.FIRST_WEEK]} component={FirstWeek} />
          <Route exact path={items[DashboardItem.USAGE]} component={Usage} />
          <Route exact path={items[DashboardItem.RESET_TRIALS]} component={ResetTrials} />
          <Route exact path={items[DashboardItem.UNREDEEMED_USERS]} component={UnredeemedUsers} />
          <Route exact path={items[DashboardItem.SCHEDULED_EMAILS]} component={ScheduledEmails} />
          <Route exact path={items[DashboardItem.SYLLABUS_IMPORTS]} component={SyllabusImports} />
          <Route exact path={items[DashboardItem.AI_USAGE]} component={AiUsage} />
        </Content>
      </Wrapper>
    </Container>
  );
};

const getSelectedKey = (pathname: string) => {
  return Object.entries(items).find(([, path]) => path === pathname)?.[0] || DashboardItem.SUBSCRIBED_USERS;
};

export default Dashboard;

const Container = styled(Layout)`
  display: flex;
  flex: 1;
`;

const Wrapper = styled(Layout)`
  padding: 10px;
`;

const Content = styled(AntContent)`
  background-color: ${colors.backgroundDark};
  display: flex;
`;

const Sider = styled(AntSider)`
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  margin-right: 10px;
`;

const SiderItem = styled(AntMenuItem)``;
